import {PermissionType, RoleBasedPermission} from '@hconnect/apiclient'
import {Feature} from '@hconnect/common/enums'

export const ROUTES = {
  BASE: {
    path: '/',
    SUITE_REDIRECT: {
      path: '/suite/:hierarchyId'
    },
    PLANT_SELECTOR: {
      path: '/plants',
      PLANT: {
        path: '/plants/:plantCode',
        STORAGES: {
          path: '/plants/:plantCode/storages'
        },
        ASSETS: {
          path: '/plants/:plantCode/assets',
          ASSET_TYPE: {
            path: '/plants/:plantCode/assets/:assetType',
            ID: {
              path: '/plants/:plantCode/assets/:assetType/id',
              ASSET_ID: {
                path: '/plants/:plantCode/assets/:assetType/id/:assetId'
              }
            },
            NEW_ASSET: {
              path: '/plants/:plantCode/assets/:assetType/new'
            }
          }
        },
        MATERIALS: {
          path: '/plants/:plantCode/materials',
          TYPE: {
            path: '/plants/:plantCode/materials/type',
            MATERIAL_TYPE: {
              path: '/plants/:plantCode/materials/type/:materialType',
              ID: {
                path: '/plants/:plantCode/materials/type/:materialType/id',
                MATERIAL_ID: {
                  path: '/plants/:plantCode/materials/type/:materialType/id/:materialId'
                }
              },
              NEW_MATERIAL: {
                path: '/plants/:plantCode/materials/type/:materialType/new'
              }
            }
          }
        },
        KPI_CALCULATION: {
          path: '/plants/:plantCode/kpi'
        },
        SAMPLING_POINTS: {
          path: '/plants/:plantCode/samplingPoints'
        },
        MEASUREMENTS: {
          path: '/plants/:plantCode/measurements'
        },
        PLANT_SETUP: {
          path: '/plants/:plantCode/plantSetup',
          NODE: {
            path: '/plants/:plantCode/plantSetup/:nodeId',
            NODE_TAB: {
              path: '/plants/:plantCode/plantSetup/:nodeId/:nodeTab'
            }
          }
        },
        KILN_CONFIG: {
          relPath: 'kilnConfig/:kilnId/config',
          path: '/plants/:plantCode/kilnConfig/:kilnId/config'
        }
      }
    },
    NOT_AUTHORIZED: {
      path: '/403'
    },
    NOT_FOUND: {
      path: '/404'
    }
  }
} as const

export const PLANT_ROUTES = ROUTES.BASE.PLANT_SELECTOR.PLANT

export enum RouteName {
  NOT_AUTHORIZED = 'notAuthorized',
  NOT_FOUND = 'notFound',
  SETTINGS = 'settings',
  STORAGES_SETTINGS = 'storagesSettings',
  ASSETS_SETTINGS = 'assetsSettings',
  MATERIALS_SETTINGS = 'materialsSettings',
  KPI_CALCULATION = 'kpiCalculationSettings',
  MEASUREMENTS = 'measurementsSettings',
  SAMPLING_POINTS = 'samplingPointsSettings',
  PLANT_SETUP = 'plantSetup',
  KILN_CONFIG = 'kilnConfig'
}

export const ROUTES_PERMISSIONS = {
  MEASUREMENTS: 'VIEW_MATERIALS',
  SAMPLING_POINTS: 'VIEW_MATERIALS'
} as const

export const PLANT_SETUP_PERMISSION_TYPES: [PermissionType, ...PermissionType[]] = [
  'VIEW_UPM',
  ...Object.values(RoleBasedPermission)
]

export const MATERIALS_PERMISSION_TYPES: [PermissionType, ...PermissionType[]] = [
  'VIEW_MATERIALS',
  ...Object.values(RoleBasedPermission)
]

type RouteType = {
  name: RouteName
  permissionType: PermissionType
  path: `${string}/${string}`
  featureType?: Feature
}

/**
 * Main settings routes in order with permissions
 */

export const mainRoutes: RouteType[] = [
  {
    name: RouteName.PLANT_SETUP,
    permissionType: 'VIEW_UPM',
    path: PLANT_ROUTES.PLANT_SETUP.path,
    featureType: Feature.UpmAssetsAndStorages
  },
  {
    name: RouteName.STORAGES_SETTINGS,
    permissionType: 'VIEW_MATERIAL_STORAGE',
    path: PLANT_ROUTES.STORAGES.path
  },
  {
    name: RouteName.ASSETS_SETTINGS,
    permissionType: 'VIEW_ASSETS',
    path: PLANT_ROUTES.ASSETS.path
  },
  {
    name: RouteName.MATERIALS_SETTINGS,
    permissionType: 'VIEW_MATERIALS',
    path: PLANT_ROUTES.MATERIALS.path
  },
  {
    name: RouteName.SAMPLING_POINTS,
    permissionType: ROUTES_PERMISSIONS.SAMPLING_POINTS,
    path: PLANT_ROUTES.SAMPLING_POINTS.path
  },
  {
    name: RouteName.MEASUREMENTS,
    permissionType: ROUTES_PERMISSIONS.MEASUREMENTS,
    path: PLANT_ROUTES.MEASUREMENTS.path
  },
  {
    name: RouteName.PLANT_SETUP,
    permissionType: 'VIEW_UPM',
    path: PLANT_ROUTES.PLANT_SETUP.path
  }
]
